import { render, staticRenderFns } from "./EfsMdMmGroupModal.vue?vue&type=template&id=23a5462e&"
import script from "./EfsMdMmGroupModal.vue?vue&type=script&lang=js&"
export * from "./EfsMdMmGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports